import React, { useState } from 'react';
import { Heart } from 'lucide-react';
import { importData } from '../utils/storage';
import '../Setup.css';

const Setup = ({ onComplete, initialData = {}, gradientColors }) => {
  const [startDate, setStartDate] = useState(initialData.startDate || '');
  const [partnerNames, setPartnerNames] = useState(
    initialData.partnerNames || { person1: '', person2: '' }
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    if (startDate && partnerNames.person1 && partnerNames.person2) {
      onComplete({ startDate, partnerNames });
    }
  };

  const handleImport = (e) => {
    const file = e.target.files[0];
    importData(file, (data, error) => {
      if (error) {
        alert(error);
      } else {
        onComplete(data);
      }
    });
  };

  return (
    <div className="setup-container">
      <div className="floating-hearts">
        {[...Array(8)].map((_, i) => (
          <Heart key={i} className="floating-heart" style={{ animationDelay: `${i * 0.8}s` }} />
        ))}
      </div>
      
      <div className="setup-card">
        <h1 className="setup-title">Our Love Story</h1>
        <p className="setup-subtitle">Begin counting the moments that matter</p>
        
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label>First Name</label>
            <input
              type="text"
              value={partnerNames.person1}
              onChange={(e) => setPartnerNames({...partnerNames, person1: e.target.value})}
              placeholder="Your name"
              required
            />
          </div>
          
          <div className="input-group">
            <label>Second Name</label>
            <input
              type="text"
              value={partnerNames.person2}
              onChange={(e) => setPartnerNames({...partnerNames, person2: e.target.value})}
              placeholder="Their name"
              required
            />
          </div>
          
          <div className="input-group">
            <label>When It All Began</label>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              required
            />
          </div>
          
          <button type="submit" className="btn-primary">
            <Heart size={18} />
            Start Counting
          </button>
        </form>

        <div className="divider">or</div>

        <label className="btn-secondary" htmlFor="import-file">
          Import Data
          <input
            id="import-file"
            type="file"
            accept=".json"
            onChange={handleImport}
            style={{ display: 'none' }}
          />
        </label>
      </div>
    </div>
  );
};

export default Setup;